export default __webpack_public_path__ + "static/bestview-grounds1-88eb5893a9d8a3de138f75f968348dfe.jpg";